export default "__VITE_ASSET__Dw206Gfg__"